import ja from "../messagesJson/ja.json";
export const PartialMessages = {
    ja,
} as const;
